import Blog from  '../img/blogs/Blog.png';
import dev from  '../img/blogs/dev.png';
import tata from  '../img/blogs/tata.png';
import scavengers from '../img/portImages/12.png'
import lybrate from '../img/portImages/lybrate.png'
const blogs = [
    {
        id: 1,
        title: 'Building Scavenger App',
        date: 10,
        month: 'Nov 2021',
        src:"https://medium.com/@shikhaprasad36/scavengers-the-e-waste-management-app-fdf971be707b",
        image: scavengers
    },
    {
        id: 2,
        title: 'Building clone of Lybrate Website',
        date: "26",
        src:"https://medium.com/@shikhaprasad36/clone-of-lybrate-with-backend-3034bd1c8497",
        month: 'Aug 2021',
        image: lybrate
    },
    // {
    //     id: 3,
    //     title: 'Building clone of the TataClick Website',
    //     date: "03",
    //     src:"https://hashnode.com/post/tatacliq-clone-ckvj97qae00cyazs1dr51b6xw",
    //     month: 'Oct 2021',
    //     image: tata
    // }

]

export default blogs;